import {Path} from 'react-hook-form'
import {
  IApplicationFormData,
  IWizardOtherOccupant,
  IWizardPet,
  IWizardVehicle,
} from '../../../models/application-form'

export const petPath = (index: number, field: keyof IWizardPet): Path<IApplicationFormData> => {
  return `pets.${index}.${field}` as Path<IApplicationFormData>
}

export const vehiclePath = (
  index: number,
  field: keyof IWizardVehicle
): Path<IApplicationFormData> => {
  return `vehicles.${index}.${field}` as Path<IApplicationFormData>
}

export const otherOccupantPath = (
  index: number,
  field: keyof IWizardOtherOccupant
): Path<IApplicationFormData> => {
  return `otherOccupants.${index}.${field}` as Path<IApplicationFormData>
}
